import isObject from '#shared/util/isObject.js';

import cBreadcrumbItem from '#themes/default/default/components/breadcrumbItem/breadcrumbItem.js';

import template from './breadcrumb.html' with { type: 'html' };

export default {
	name: 'CBreadcrumb',
	components: {
		cBreadcrumbItem
	},
	props: {
		isCompany: {
			type: Boolean,
			default: false
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		isNewMethod: {
			type: Boolean,
			default: false
		},
		page: {
			type: Object,
			default: () => null
		},
		order: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		isConfirmOrderPage() {
			return isObject(this.page) && this.page.number === 3;
		}
	},
	template
};
